import { render, staticRenderFns } from "./formList.vue?vue&type=template&id=91c01352&"
import script from "./formList.vue?vue&type=script&lang=js&"
export * from "./formList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports